import React, { ReactElement } from 'react';

export default function HomeIcon(): ReactElement | null {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="119"
      fill="none"
      viewBox="0 0 108 119"
    >
      <path
        fill="#EBE8EF"
        fillOpacity="0.6"
        d="M67.622 25H40.467C23.088 25 9 39.07 9 56.425V87.12c0 17.355 14.088 31.424 31.467 31.424h27.155c17.379 0 31.466-14.069 31.466-31.424V56.424C99.088 39.07 85.001 25 67.623 25z"
      ></path>
      <path
        fill="#D0C7D8"
        stroke="#7C698E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19.57 105h69V70.225L54.07 42l-34.5 28.635V105z"
      ></path>
      <path
        stroke="#7C698E"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M15.877 28.743a3.874 3.874 0 003.876-3.871A3.874 3.874 0 0015.877 21 3.874 3.874 0 0012 24.872a3.874 3.874 0 003.877 3.871z"
      ></path>
      <path
        stroke="#907A9F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M86.605 47.204a2.604 2.604 0 002.606-2.602A2.604 2.604 0 0086.605 42 2.604 2.604 0 0084 44.602a2.604 2.604 0 002.605 2.602z"
      ></path>
      <path
        stroke="#7C698E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M28.22 55V42h5.85v8.5"
      ></path>
      <path
        stroke="#D0C7D8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 105h106"
      ></path>
      <path
        fill="#D0C7D8"
        fillOpacity="0.4"
        d="M20 71s3 4.5 5 12.5c.764 3.055-1.5 8.5 1.5 12s51 4.246 51 9.5H20V71z"
      ></path>
      <path
        fill="#F4F1F6"
        stroke="#56426A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M54.1 34L14 67.42v8.25l40.1-33.41 39.96 32.81v-8.25L54.1 34z"
      ></path>
      <path
        fill="#F4F1F6"
        stroke="#7C698E"
        strokeWidth="2"
        d="M45 71H63V105H45z"
      ></path>
      <path fill="#F4F1F6" d="M45 100H63V105H45z"></path>
      <path stroke="#7C698E" strokeWidth="2" d="M45 71H63V105H45z"></path>
      <path
        fill="#F4F1F6"
        stroke="#7C698E"
        strokeWidth="2"
        d="M26 71H39V87H26z"
      ></path>
      <path
        fill="#F4F1F6"
        stroke="#7C698E"
        strokeWidth="2"
        d="M69 71H82V87H69z"
      ></path>
      <path fill="#F4F1F6" d="M26 83H39V87H26z"></path>
      <path fill="#F4F1F6" d="M69 83H82V87H69z"></path>
      <path stroke="#7C698E" strokeWidth="2" d="M26 71H39V87H26z"></path>
      <path stroke="#7C698E" strokeWidth="2" d="M69 71H82V87H69z"></path>
      <path
        fill="#E8E3EB"
        fillRule="evenodd"
        d="M21.678 11.107c0 .952.218 1.853.607 2.656a4.412 4.412 0 002.473 7.474 6.107 6.107 0 1011.573 3.905 7.126 7.126 0 00-2.483-13.291 6.107 6.107 0 10-12.17-.744z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#EBE8EF"
        d="M37.46 4.915a2.46 2.46 0 002.461-2.458A2.46 2.46 0 0037.461 0 2.46 2.46 0 0035 2.457a2.46 2.46 0 002.46 2.458z"
      ></path>
      <path
        fill="#E8E3EB"
        d="M26.718 35.431A1.717 1.717 0 1025 33.716c0 .947.77 1.715 1.718 1.715z"
      ></path>
    </svg>
  );
}
